import { Switch, styled } from "@mui/material"

const CustomSwitch = styled( ( props ) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} sx={{ transform: `scale(${props.size === "small" ? "0.8" : "1"})` }} />
) )( ( { theme, ...props } ) => ( {
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 3,
        transitionDuration: '300ms',
        transform: `translateX(1px)`,
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& .MuiSwitch-thumb': {
                backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 -960 960 960"><path fill="${encodeURIComponent(
                    '#000',
                )}" d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>')`,
            },
            '& + .MuiSwitch-track': {
                backgroundColor: theme.palette[props.color || "secondary"].main,
                opacity: 1,
                border: 0,
                ...theme.applyStyles( 'dark', {
                    backgroundColor: theme.palette[props.color || "secondary"].main,
                } ),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles( 'dark', {
                color: theme.palette.grey[600],
            } ),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles( 'dark', {
                opacity: 0.3,
            } ),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 -960 960 960"><path fill="${encodeURIComponent(
            '#39393D',
        )}" d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>')`,
        backgroundPosition: "center center",
        width: 20,
        height: 20,
    },

    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#b7b7b7ff',
        border: theme.theme === 'dark' ? `2px solid white` : `2px solid #39393D`,
        padding: "2px",
        opacity: 1,
        transition: theme.transitions.create( ['background-color'], {
            duration: 500,
        } ),
        ...theme.applyStyles( 'dark', {
            backgroundColor: '#39393D',
        } ),
    },
} ) )
export default CustomSwitch
